module.exports = __webpack_public_path__ + "static/media/bn_5.2c911761.png";